module.exports = __webpack_public_path__ + "fonts/intelo-regular.65420de.woff2";